/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Speaker_Assignment_AlwaysInputs */

const en_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always`)
};

const fr_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toujours`)
};

const de_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stets`)
};

const it_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sempre`)
};

const ru_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всегда`)
};

const es_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siempre`)
};

const zh_cn2_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总是`)
};

const ja_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつも`)
};

const hi_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमेशा`)
};

const pt_pt2_options_editor_speaker_assignment_always = /** @type {(inputs: Options_Editor_Speaker_Assignment_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sempre`)
};

/**
* | output |
* | --- |
* | "Always" |
*
* @param {Options_Editor_Speaker_Assignment_AlwaysInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_speaker_assignment_always = /** @type {((inputs?: Options_Editor_Speaker_Assignment_AlwaysInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Speaker_Assignment_AlwaysInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_speaker_assignment_always(inputs)
	if (locale === "de") return de_options_editor_speaker_assignment_always(inputs)
	if (locale === "it") return it_options_editor_speaker_assignment_always(inputs)
	if (locale === "ru") return ru_options_editor_speaker_assignment_always(inputs)
	if (locale === "es") return es_options_editor_speaker_assignment_always(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_speaker_assignment_always(inputs)
	if (locale === "ja") return ja_options_editor_speaker_assignment_always(inputs)
	if (locale === "hi") return hi_options_editor_speaker_assignment_always(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_speaker_assignment_always(inputs)
	return en_options_editor_speaker_assignment_always(inputs)
});